<div
  class="inpage-navigation-sticky"
  [ngClass]="{ 'inpage-navigation-sticky--on-top': isSticky }"
  #inpageNavigation
>
  <div class="inpage-navigation container">
    <span class="inpage-navigation-title">{{ titleText }}:</span>
    <div
      class="inpage-navigation"
      [ngClass]="{ 'inpage-navigation--margin-right': isSticky }"
    >
      <div
        draggable="true"
        class="inpage-navigation__slider"
        (dragstart)="startDrag($event)"
        (dragenter)="startDragging($event)"
        (dragover)="moveEvent($event)"
        (dragend)="stopDragging()"
        #slider
      >
        <hdi-link
          *ngFor="let inpageItem of inpageMenu"
          class="inpage-navigation__slider__item"
          [label]="inpageItem.title | capitalize"
          [title]="inpageItem.hoverText ?? ''"
          [href]="'/'"
          [fragment]="inpageItem.url"
          [hrefType]="HrefType.ANGULAR_ROUTE"
          [type]="LinkType.NOSTYLES"
          [ngClass]="{
            'inpage-navigation__slider__item--active':
              inpageItem.url === activeSectionId.getValue(),
          }"
        >
        </hdi-link>
      </div>
    </div>
    <ng-container *ngIf="isSticky && CTAButton">
      <hdi-button
        class="inpage-navigation-button"
        [label]="buttonLabel | capitalize"
        [title]="buttonTitle"
        [iconName]="buttonIcon"
        [type]="
          isSmallScreen ? buttonType.SQUARED_PRIMARY : buttonType.PRIMARY_ICON
        "
        [href]="CTALink"
        [fragment]="CTAFragment ?? ''"
        [hrefType]="
          CTALinkType === 'internal'
            ? HrefType.ANGULAR_ROUTE
            : HrefType.EXTERNAL
        "
        [target]="CTALinkType === 'external' ? '_blank' : '_self'"
      ></hdi-button>
    </ng-container>
  </div>
</div>
